/* 
    List module 
*/
import cloneDeep from 'lodash/cloneDeep';
import listConfigBuilder from './list-config-builder';
import chartUtils from '../../../utils/chart-utils';

var list = function list() {

    // Render List widget
    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            Model = widgetConfig.Model,
            Width = widgetConfig.Width,
            Height = widgetConfig.Height,
            Cloud = widgetConfig.Cloud,
            Data = widgetConfig.Data,
            ListConfig = widgetConfig.ListConfig;


        var modelName = Model;
        var cloudName = Cloud;
        var fields = ListConfig.Fields;
        var crumbFormat = {
            "CloudName": cloudName,
            "ModelName": modelName,
            "Type": "Node",
            "Name": "",
            FieldName: "",
            "Value": ""
        };
        var el = window.document.querySelector('#' + ContainerId);
        var data = JSON.parse(chartUtils.replaceAll(Data.Data, '\x01', ""));
        var width = Width,
            height = Height;

        var listContainer = window.document.createElement("div");
        listContainer.setAttribute("style", "width:100%;height:" + height + "px;overflow:auto;");
        var className = 'visor-list-container';
        listContainer.setAttribute("class", className);
        var listStyle = {
            0: "list-style-type: square ",
            1: "list-style-type: disc",
            2: "list-style-type: circle"
        };
        el.appendChild(listContainer);
        var list = window.document.createElement("ul");
        list.setAttribute("class", "list-levels");
        listContainer.appendChild(list);
        var listData = structureDataInListFormat(data);
        createListHtml(listData, list, 0, fields, crumbFormat);

        // Structure data in list format
        function structureDataInListFormat(data) {
            function createList(currentLevel, fieldLevel, tempObj, fieldsList, listObj) {
                if (currentLevel === fieldLevel) {
                    var fieldValue = replaceFalsyValues(listObj[fieldsList[fieldLevel]]);
                    if (!(fieldValue in tempObj)) {
                        tempObj[fieldValue] = {};
                    }
                    return tempObj;
                }

                var currentFieldValue = replaceFalsyValues(listObj[fieldsList[currentLevel]]);
                currentLevel += 1;
                tempObj[currentFieldValue] = createList(currentLevel, fieldLevel, tempObj[currentFieldValue], fieldsList, listObj);
                return tempObj;
            }

            function replaceFalsyValues(data) {
                return data === null || data === undefined || !data.toString().length ? '--' : data;
            }

            var fieldsList = [];
            var formattedData = {};
            fields.forEach(function (field) {
                fieldsList[field.Level - 1] = field.FieldName;
            });

            fieldsList.forEach(function (field, index) {
                data.forEach(function (listObj) {
                    var fieldLevel = index;
                    formattedData = createList(0, fieldLevel, formattedData, fieldsList, listObj);
                });
            });
            return formattedData;
        }

        // Create list html string
        function createListHtml(data, list, counter, fields, crumbFormat) {
            if (!Object.keys(data).length) {
                return list;
            }
            counter++;
            var ul = document.createElement('ul');
            list.appendChild(ul);
            Object.keys(data).forEach(function (value) {
                var style = listStyle[counter % 3];
                var li = document.createElement('li');
                li.setAttribute('style', style);
                li.setAttribute('title', value);
                if (fields[counter - 1].CrumbMetaName != null && fields[counter - 1].CrumbMetaName.trim().length > 0 && fields[counter - 1].CrumbMetaName != null && fields[counter - 1].CrumbMetaName.trim().length > 0) {
                    var crump = crumbFormat;
                    crump["Name"] = fields[counter - 1].CrumbMetaName;
                    crump["FieldName"] = fields[counter - 1].CrumbFieldName;
                    crump["Value"] = value;
                    crump["DisplayFieldName"] = fields[counter - 1].CrumbDisplayFieldName;
                    crump["DisplayValue"] = value;
                    li.setAttribute("class", "dataviz anchor");
                    li.setAttribute("coord", JSON.stringify(crump));
                    li.textContent = value;
                    ul.appendChild(li);
                    createListHtml(data[value], li, counter, fields, crumbFormat);
                } else {
                    li.textContent = value;
                    ul.appendChild(li);
                    createListHtml(data[value], li, counter, fields, crumbFormat);
                }
            });
            list.appendChild(ul);
            return list;
        }
    };

    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = listConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default list();